function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import ACTION_TYPES from "../actions/actionTypes";
export default function crossSliceReducer(state, action) {
  if (!action) return state;

  // eslint-disable-next-line default-case
  switch (action.type) {
    case ACTION_TYPES.PROFILE_UPDATE_CARD_COMPLETED:
      return updatePagesFromCards(state, action);
  }
  return state;
}
var findCardInPages = function findCardInPages(pages, cardName) {
  for (var pName in pages) {
    var cardsArr = pages[pName].cards;
    if (cardsArr && cardsArr.indexOf(cardName) > -1) return pName;
  }
  return null;
};
var updateStatus = function updateStatus(state) {
  var barProps = [];
  for (var p in state.pages) {
    barProps.push({
      stepLabel: state.pages[p].pageLabel,
      completed: state.pages[p].completed
    });
  }
  return barProps;
};

//need the card stage.
var updatePage = function updatePage(card, page) {
  var cardsInPage = page.cards.map(function (c) {
    return card.cards[c];
  });
  // page is completed only if all cards are completed.
  page.completed = !cardsInPage.some(function (e) {
    //check if some of them have false completed statue.
    return !(e.completed === true);
  });
};
export function updatePagesFromCards(state, resp) {
  var _resp$value = resp.value,
    type = _resp$value.type,
    currentCard = _resp$value.currentCard;
  var page = state.page,
    card = state.card;
  var pages = _objectSpread({}, page.pages);
  if (!page || page && page.showAllPage) {
    //update all pages.
    for (var pName in page.pages) {
      updatePage(card, pages[pName]);
    }
  } else {
    var pageName = findCardInPages(page.pages, currentCard);
    if (!pageName) return state;
    var cardPage = pages[pageName];
    updatePage(card, cardPage);
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    page: _objectSpread(_objectSpread({}, page), {}, {
      progressBarProps: {
        showCompletedIcon: page.showCompletedIcon,
        steps: updateStatus(page)
      }
    })
  });
}